<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Urlopy moich pracowników</span>
        <h3 class="page-title">Lista urlopów</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          style="width: 175px;"
          theme="success"
          @click.prevent="openModal">
          <i class="material-icons">book_online</i>
          Pobierz raport
        </d-button>
      </d-col>
    </d-row>
    <br>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="holidays-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię lub nazwisko pracownika"
          v-model="filters.search"/>
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="statusFilter"
          v-model="filters.accountStatus"
          placeholder="Sortuj według statusu"
          :searchable="false"
          label="text">
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Imię i nazwisko</th>
          <th scope="col" class="border-0">Start urlopu</th>
          <th scope="col" class="border-0">Koniec urlopu</th>
          <th scope="col" class="border-0">Rodzaj</th>
          <th scope="col" class="border-0">Zgodność z planem urlopowym</th>
          <th scope="col" class="border-0">Status</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(holiday, index) of holidays"
          :key="'user-' + index">
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.user_name  }}
          </td>
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.date_start }}
          </td>
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.date_end }}
          </td>
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.type_name }}
          </td>
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? 'color: #17c671;' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.type_id === 3 ? (holiday.plan_id > 0 ? 'TAK' : (holiday.plan_id === 0 ? 'NIE' : '')) : ''}}
          </td>
          <td class="align-middle" :style="holiday.status === 'ACCEPTED' ? 'color: #17c671;' : (holiday.status === 'REJECTED' ? 'color: #ad1535;' : (holiday.status === 'NEW' ? '' : 'color: #ffb400;'))">
            {{ holiday.status === 'NEW' ? 'Oczekuje akceptacji' : ( holiday.status === 'ACCEPTED' ? 'Zaakceptowany' : ( holiday.status === 'REJECTED' ? 'Odrzucony' : 'Anulowany')) }}
          </td>
          <td class="align-middle" style="width: 320px;">
            <d-dropdown
              class="dropdownStatus"
              v-if="(holiday.status !== 'CANCELED') && ((userData.role === 'R_HR') || (userData.role === 'R_ADMIN'))"
              style="width: 30%"
              :theme=" holiday.status === 'NEW' ? 'secondary' : ( holiday.status === 'ACCEPTED' ? 'success' : ( holiday.status === 'REJECTED' ? 'danger' : 'warning'))"
              :menu-id="`dropdown-${holiday.id}`"
              :text="holiday.status !== 'ACCEPTED' && holiday.status !== 'REJECTED' ?
              (holiday.status === 'NEW' ? 'Dodaj status' : 'Anulowany') : (holiday.status === 'ACCEPTED' ? 'Zaakceptowany' : 'Odrzucony')">
                <d-dropdown-item>
                  <d-button
                    :disabled="holiday.status !== 'NEW'"
                    style="width: 100%"
                    theme="success"
                    :menu-id="`dropdown-accepted-${holiday.id}`"
                    @click="handleAccepted(holiday.id)">
                    Zaakceptuj
                  </d-button>
                </d-dropdown-item>
                <d-dropdown-item>
                  <d-button
                    :disabled="holiday.status !== 'NEW'"
                    style="width: 100%"
                    theme="danger"
                    :menu-id="`dropdown-rejected-${holiday.id}`"
                    @click="handleRejected(holiday.id)">
                    Odrzuć
                  </d-button>
                </d-dropdown-item>
                <d-dropdown-item>
                  <d-button
                          :disabled="holiday.status !== 'NEW'"
                          style="width: 100%"
                          theme="warning"
                          :menu-id="`dropdown-rejected-${holiday.id}`"
                          @click="handleCancelled(holiday.id)">
                    Anulowany
                  </d-button>
                </d-dropdown-item>
              </d-dropdown>
            <d-button
              v-if="holiday.status === 'ACCEPTED'"
              theme="info"
              class="ml-2"
              title="Pobierz wniosek urlopowy"
              :disabled="downloading !== false"
              @click.prevent="downloadHoliday(holiday.id)">
              <template v-if="downloading !== holiday.id"><i class="material-icons">cloud_download</i></template>
              <template v-else>
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </template>
            </d-button>
            <d-button
              theme="primary"
              @click.prevent="$router.push({path: '/urlopy-pracownikow/edycja/' + holiday.id, query: { back: 'list' } })"
              class="ml-2"
              title="Szczegóły urlopu">
              <i class="material-icons">person_search</i>
            </d-button>
            <d-button
              class="ml-2"
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeHoliday(holiday.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
          <d-modal
            v-if="showAccepted || showRejected || showCancelled">
            <d-modal-header>
              <d-modal-title class="mt-3 mb-3">
                {{showAccepted ? 'Potwierdzasz akceptację urlopu ?' : (showCancelled ? 'Potwierdzasz anulowanie urlopu ?' : 'Potwierdzasz odrzucenie urlopu ?')}}
              </d-modal-title>
            </d-modal-header>
            <d-modal-body>
              <div class="form-group">
                <label for="boss_description">
                  Dodaj adnotacje:
                </label>
                <validation-provider
                  name="description"
                  v-slot="{ errors }">
                  <d-form-textarea
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.boss_description" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="popup-box-buttons">
                <d-button
                  theme="success"
                  class="text-nowrap"
                  @click.prevent="submitForm(data.id, (showAccepted ? 'ACCEPTED' : (showCancelled ? 'CANCELLED' : 'REJECTED')))">
                  Potwierdź
                </d-button>
                <d-button
                  theme="secondary"
                  class="text-nowrap ml-3"
                  @click.prevent="handleClose">
                  Anuluj
                </d-button>
              </div>
            </d-modal-body>
          </d-modal>
        </tr>
        <tr v-if="holidays.length === 0">
          <td
            colspan="7"
            class="text-center">
            Brak urlopów do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>
      <holidays-children-report
        :key="modalKey"
        :close-modal="closeModal"
        :show-modal="showModal"
        :label="'Wygeneruj raport urlopowy'"/>
      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Vue from 'vue';
import HolidaysChildrenReport from './HolidaysChildrenReport';

export default {
  name: 'holidays',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    HolidaysChildrenReport,
    DatePicker,
    'pagination': Pagination
  },
  data() {
    return {
      data: {
        status: '',
        id: '',
        boss_description: ''
      },
      holidays: [],
      users: [],
      showModal: false,
      reportMonth: '',
      reportInstitutionId: '',
      downloadingReport: false,
      modalKey: 0,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      showAccepted: false,
      showRejected: false,
      showCancelled: false,
      downloading: false,
      filters: {
        search: '',
        accountStatus: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
    this.getUsersList();
    this.userAccountGet();
  },
  computed: {
    statusFilter () {
      return [
        {
          text: 'Zaakceptowane',
          value: 'ACCEPTED'
        },
        {
          text: 'Odrzucone',
          value: 'REJECTED'
        },
        {
          text: 'Anulowane',
          value: 'CANCELLED'
        },
        {
          text: 'Oczekuje akceptacji',
          value: 'NEW'
        }
      ];
    },
    userData () {
      return this.$store.getters.getAccount
    },
  },
  methods: {
    downloadHoliday (holidayID) {
      this.downloading = true;
      this.$http.post('/holidays/get-holiday-form/' + holidayID, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'Urlop-nr-';
        link.setAttribute('download', filename + holidayID + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloading = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.downloading = false;
      });
    },
    openModal () {
      this.modalKey += 1;
      this.showModal = true;
    },
    closeModal () {
      this.showModal = false;
      this.modalKey += 1;
    },
    downloadReport () {
      let params = {};
      if (this.reportMonth !== null) {
        params.report_date = this.reportMonth;
      }

      if (this.reportInstitutionId !== null) {
        params.institution_id = this.reportInstitutionId;
      }
      this.downloading = true;
      this.$http.post('/reports/monthly', {
        params
      }, {
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'raport-';
        let institution = '-placowka-';
        link.setAttribute('download', filename + this.reportMonth + institution + this.reportInstitutionId + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloading = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.downloading = false;
        this.only_plans = false;
      });
    },
    removeHoliday (holidayID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/holidays/delete/',
        id: holidayID,
        successTitle: 'Usunięto urlop pracownika',
        successText: 'Wybrany urlop pracownika został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten urlop pracownika?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie urlop pracownika nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    handleClose() {
      this.showAccepted = false;
      this.showRejected = false;
      this.showCancelled = false;
    },
    handleAccepted(id) {
      this.showAccepted = true;
      this.data.id = id
    },
    handleRejected(id) {
      this.showRejected = true;
      this.data.id = id
    },
    handleCancelled(id) {
      this.showCancelled = true;
      this.data.id = id
    },
    getUsersList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search,
      };
      if (this.filters.accountStatus !== null && this.filters.accountStatus && this.filters.accountStatus.value) {
        where.status = this.filters.accountStatus.value;
      }
      ListUtils.loadItemsData(this, {
        endpoint: 'holidays/children-items?page=' + this.currentPage,
        listField: 'holidays',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        accountStatus: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['holidays-filters-form'], this.debouncedLoadFilteredData);
    },
    submitForm (holidayID, statusOption) {
      let formDataToSend = {
        status: statusOption,
        boss_description: this.data.boss_description
      };
      let endpointUrl = '/holidays/update-status/' + holidayID;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano urlop pracownika',
        successText: 'Urlop pracownika został zaktualizowany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja urlopu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.showAccepted = false;
          this.showRejected = false;
          this.showCancelled = false;
          this.loadFilteredData();
        }
      })
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables/mixins';
  .popup-box-buttons {
    @include popupButtons
  }
  @import "../../assets/scss/layout/holidays-children";
</style>
